import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function ConfidaysLoader({ onFinish }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);

      setTimeout(() => {
        onFinish?.();
      }, 700);
    }, 2800);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          className="
            fixed
            inset-0
            z-[9999]

            flex
            items-center
            justify-center

            overflow-hidden

            bg-gradient-to-br
            from-[#fff8fc]
            via-[#f9f5ff]
            to-[#eef4ff]
          "
        >
          {/* ================= BLUR BACKGROUNDS ================= */}

          <motion.div
            animate={{
              scale: [1, 1.15, 1],
              opacity: [0.25, 0.4, 0.25],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
            }}
            className="
              absolute
              top-[-120px]
              left-[-120px]

              w-[420px]
              h-[420px]

              rounded-full

              bg-pink-300

              blur-3xl
            "
          />

          <motion.div
            animate={{
              scale: [1, 1.1, 1],
              opacity: [0.2, 0.35, 0.2],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
            }}
            className="
              absolute
              bottom-[-120px]
              right-[-120px]

              w-[420px]
              h-[420px]

              rounded-full

              bg-blue-300

              blur-3xl
            "
          />

          {/* ================= CENTER CONTENT ================= */}

          <div className="relative z-10 flex flex-col items-center">
            {/* GLOW */}

            <motion.div
              animate={{
                scale: [1, 1.15, 1],
                opacity: [0.4, 0.7, 0.4],
              }}
              transition={{
                duration: 2.5,
                repeat: Infinity,
              }}
              className="
                absolute

                w-[220px]
                h-[220px]

                rounded-full

                bg-pink-200/40

                blur-3xl
              "
            />

            {/* LOGO */}

            <motion.div
              initial={{
                opacity: 0,
                scale: 0.8,
                y: 20,
              }}
              animate={{
                opacity: 1,
                scale: [1, 1.03, 1],
                y: [0, -4, 0],
              }}
              transition={{
                opacity: {
                  duration: 0.8,
                },

                scale: {
                  duration: 3,
                  repeat: Infinity,
                },

                y: {
                  duration: 3,
                  repeat: Infinity,
                },
              }}
              className="relative"
            >
              <img
                src="/logo.png"
                alt="Confidays"
                className="
                  w-[220px]
                  md:w-[300px]

                  object-contain
                "
              />
            </motion.div>

            {/* TAGLINE */}

            <motion.p
              initial={{
                opacity: 0,
                y: 15,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.6,
                duration: 0.7,
              }}
              className="
                mt-4

                text-[#1A237E]

                text-sm
                md:text-base

                tracking-[4px]
                uppercase

                font-medium
              "
            >
              Comfort • Confidence • Care
            </motion.p>

            {/* LOADING DOTS */}

            <div className="flex gap-2 mt-8">
              {[0, 1, 2].map((dot) => (
                <motion.div
                  key={dot}
                  animate={{
                    y: [0, -8, 0],
                    opacity: [0.4, 1, 0.4],
                  }}
                  transition={{
                    duration: 0.8,
                    repeat: Infinity,
                    delay: dot * 0.2,
                  }}
                  className="
                    w-3
                    h-3

                    rounded-full

                    bg-gradient-to-r
                    from-pink-500
                    to-[#1A237E]
                  "
                />
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
